import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import type { SubscriptionInvoice } from 'types';

type SubscriptionInvoicesResponse = {
  data: SubscriptionInvoice[];
  total: number;
  current_page: number;
  last_page: number;
  per_page: number;
};

export const getSubscriptionInvoices = async ({
  queryKey,
}: QueryFunctionContext<[string, number | undefined, number]>) => {
  const subscriptionId = queryKey[1];
  const page = queryKey[2];

  const response: SubscriptionInvoicesResponse = await baseQuery(
    `subscriptions/${subscriptionId}/invoices?page=${page}`,
  );

  return response;
};
